import { Grid } from '@mui/material';
import { TournamentSettingsOption } from 'modules/tournaments/interfaces';
import { TournamentSettingsTitle } from 'modules/tournaments/components/TournamentSettingsTitle';
import { TournamentSettingsTile } from 'modules/tournaments/components/TournamentDetails/TournamentDetailsTile';
import React, { FC } from 'react';

interface TournamentSettingsProps {
  title: string;
  tournamentSettings: TournamentSettingsOption[];
}

export const TournamentSettings: FC<TournamentSettingsProps> = ({ tournamentSettings, title }) => {
  if (!tournamentSettings?.length) {
    return null;
  }

  return (
    <>
      <TournamentSettingsTitle>{title}</TournamentSettingsTitle>
      <Grid container spacing={2}>
        {tournamentSettings?.map((setting, index) => (
          <TournamentSettingsTile key={index} {...setting} />
        ))}
      </Grid>
    </>
  );
};
